export const ARMED_SERVICE_GET_SUCCESS = 'ARMED_SERVICE_GET_SUCCESS';
export const ARMED_SERVICE_GET_FAILURE = 'ARMED_SERVICE_GET_FAILURE';

export const ARMED_SERVICE_SUCCESS = 'ARMED_SERVICE_SUCCESS';
export const ARMED_SERVICE_FAILURE = 'ARMED_SERVICE_FAILURE';
